import { render, staticRenderFns } from "./HomeBackground.vue?vue&type=template&id=26d19f6a&scoped=true&lang=pug"
import script from "./HomeBackground.vue?vue&type=script&lang=js"
export * from "./HomeBackground.vue?vue&type=script&lang=js"
import style0 from "./HomeBackground.vue?vue&type=style&index=0&id=26d19f6a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d19f6a",
  null
  
)

export default component.exports